<template>
  <div>   
    <div v-html="$t('register.text') ==='register.text' ? '': $t('register.text')"></div>


    <b-form-group v-if="$specs.showAlias">
      <b-form-text
        >{{ $t("register.alias")
        }}{{ $specs.aliasRequired || $specs.AliasRequired? "*" : "" }}</b-form-text
      >
      <b-form-input
        ref="formRegisterAlias"
        maxlength="50"
        v-model="data.alias"
        @input="inputHandler"
        autofocus 
      />
      <b-form-invalid-feedback :state="!(errorCode === 11)">{{
        $t("register.aliasRequired")
      }}</b-form-invalid-feedback>
    </b-form-group>




    <b-form-group v-if="$specs.showFirstname">
      <b-form-text
        >{{ $t("register.firstname")
        }}{{ $specs.firstnameRequired ? "*" : "" }}</b-form-text
      >
      <b-form-input
        ref="formRegisterFirstname"
        maxlength="50"
        v-model="data.firstname"
        @input="inputHandler"
        :autofocus = "$specs.showAlias ? false : true"
      />
      <b-form-invalid-feedback :state="!(errorCode === 1)">{{
        $t("register.firstnameRequired")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="$specs.showLastname">
      <b-form-text
        >{{ $t("register.lastname")
        }}{{ $specs.lastnameRequired ? "*" : "" }}</b-form-text
      >
      <b-form-input
        ref="formRegisterLastname"
        maxlength="50"
        v-model="data.lastname"
        @input="inputHandler"
      />
      <b-form-invalid-feedback :state="!(errorCode === 2)">{{
        $t("register.lastnameRequired")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="$specs.showCountry">
      <b-form-text
        >{{ $t("register.country")
        }}{{ $specs.countryRequired ? "*" : "" }}</b-form-text
      >
      <b-form-select
        ref="formRegisterCountry"
        v-model="data.countryId"
        @input="inputHandler"
        :options="countryOptions"
      />
      <b-form-invalid-feedback :state="!(errorCode === 3)">{{
        $t("register.countryRequired")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="$specs.showPostcode">
      <b-form-text
        >{{ $t("register.postcode")
        }}{{ $specs.postcodeRequired ? "*" : "" }}</b-form-text
      >
      <b-form-input
        ref="formRegisterPostcode"
        v-model="data.postcode"
        maxlength="15"
        @input="inputHandler"
      />
      <b-form-invalid-feedback :state="!(errorCode === 4)">
        {{ $t("register.postcodeRequired") }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="$specs.showDob">
      <b-form-text
        >{{ $t("register.dob")
        }}{{ $specs.dobRequired ? "*" : "" }}</b-form-text
      >
      <b-form-select
        ref="formRegisterDob"
        v-model="data.dob"
        @input="inputHandler"
        :options="yobOptions"
      />
      <b-form-invalid-feedback :state="!(errorCode === 5)">
        {{ $t("register.dobRequired") }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="$specs.showSex">
      <b-form-text
        >{{ $t("register.sex")
        }}{{ $specs.sexRequired ? "*" : "" }}</b-form-text
      >
      <div class="text-center">
        <b-form-radio-group
          v-model="data.sex"
          buttons
          button-variant="outline-primary"
        >
          <b-form-radio value="1" @input="inputHandler" ref="formRegisterSex"
            ><img src="../assets/female.svg" class="gender-img"
          /></b-form-radio>
          <b-form-radio value="2" @input="inputHandler"
            ><img src="../assets/male.svg" class="gender-img"
          /></b-form-radio>
          <b-form-radio value="3" @input="inputHandler"
            ><img src="../assets/gender.svg" class="gender-img"
          /></b-form-radio>
        </b-form-radio-group>
      </div>
      <b-form-invalid-feedback :state="!(errorCode === 6)">
        {{ $t("register.sexRequired") }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="$specs.showEmail">
      <b-form-text
        >{{ $t("register.email")
        }}{{ $specs.emailRequired ? "*" : "" }}</b-form-text
      >
      <b-form-input
        ref="formRegisterEmail"
        type="email"
        maxlength="320"
        v-model="data.email"
        @input="inputHandler"
      />
      <b-form-invalid-feedback :state="!(errorCode === 7)">
        {{ $t("register.emailRequired") }}
      </b-form-invalid-feedback>
      <b-form-invalid-feedback :state="!(errorCode === 8)">
        {{ $t("register.emailInvalid") }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="$specs.showPhone">
      <b-form-text
        >{{ $t("register.phone")
        }}{{ $specs.phoneRequired ? "*" : "" }}</b-form-text
      >
      <b-form-input
        ref="formRegisterPhone"
        type="tel"
        maxlength="20"
        v-model="data.phone"
        @input="inputHandler"
      />
      <b-form-invalid-feedback :state="!(errorCode === 9)">
        {{ $t("register.phoneRequired") }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="$specs.showProfession">
      <b-form-text
        >{{ $t("register.profession")
        }}{{ $specs.professionRequired ? "*" : "" }}</b-form-text
      >
      <b-form-input
        ref="formRegisterProfession"
        v-model="data.profession"
        maxlength="60"
        @input="inputHandler"
      />
      <b-form-invalid-feedback :state="!(errorCode === 10)">
        {{ $t("register.professionRequired") }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-text class="mt-4">
      {{ $t("register.fieldRequiredNote") }}
    </b-form-text>
    <!--<hr class="mt-5" />-->
    <b-form-group class="mt-5">
      <b-button class="float-right" @click="nextHandler">{{
        $t("register.next")
      }}</b-button>
    </b-form-group>
  </div>
</template>

<script>
import ModCountry from "../modules/ModCountry"

export default {
  name: "FormRegister",
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      data: this.value,
      countryOptions: [],
      errorCode: 0,
    }
  },
  methods: {
    inputHandler() {
      this.$emit("input", this.data)
      this.errorCode = 0
    },
     isEmail(email) {
        let regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        return regEx.test(email)
    },
    validate() {
      if (
        this.$specs.showAlias &&
        this.$specs.aliasRequired &&
        !this.data.alias
      ) {
        this.errorCode = 11
        this.$refs.formRegisterAlias.focus()
        return null
      }

      if (
        this.$specs.showFirstname &&
        this.$specs.firstnameRequired &&
        !this.data.firstname
      ) {
        this.errorCode = 1
        this.$refs.formRegisterFirstname.focus()
        return null
      }
      if (
        this.$specs.showLastname &&
        this.$specs.lastnameRequired &&
        !this.data.lastname
      ) {
        this.errorCode = 2
        this.$refs.formRegisterLastname.focus()
        return null
      }
      if (
        this.$specs.showCountry &&
        this.$specs.countryRequired &&
        !this.data.countryId
      ) {
        this.errorCode = 3
        this.$refs.formRegisterCountry.focus()
        return null
      }
      if (
        this.$specs.showPostcode &&
        this.$specs.postcodeRequired &&
        !this.data.postcode
      ) {
        this.errorCode = 4
        this.$refs.formRegisterPostcode.focus()
        return null
      }
      if (this.$specs.showDob && this.$specs.dobRequired && !this.data.dob) {
        this.errorCode = 5
        this.$refs.formRegisterDob.focus()
        return null
      }
      if (this.$specs.showSex && this.$specs.sexRequired && !this.data.sex) {
        this.errorCode = 6
        this.$refs.formRegisterSex.focus()
        return null
      }
      if(this.$specs.showEmail && this.$specs.emailRequired && !this.data.email){
        this.errorCode = 7
        this.$refs.formRegisterEmail.focus()
        return null
      }
      if(this.$specs.showEmail && this.data.email && !this.isEmail(this.data.email)){
        this.errorCode = 8
        this.$refs.formRegisterEmail.focus()
        return null
      }
      if(this.$specs.showPhone && this.$specs.phoneRequired && !this.data.phone){
        this.errorCode = 9
        this.$refs.formRegisterPhone.focus()
        return null
      }
      if(this.$specs.showProfession && this.$specs.professionRequired && !this.data.profession){
        this.errorCode = 10
        this.$refs.formRegisterProfession.focus()
        return null
      }
      return this.data
    },
    nextHandler() {
      if (this.validate()) {
        this.$emit("next", this.data)
      }
    },
  },
  computed: {
    yobOptions() {
      let now = new Date().getFullYear(),
        start = 12,
        delta = 101,
        options = []

      for (start; start < delta; start++) {
        options.push({
          value: now - start,
          text: now - start,
        })
      }

      return options
    },
  },
  watch: {
    value(val) {
      this.data = val ? val : {}
    },
  },
  created() {
    ModCountry.readAll(this.$i18n.locale).then((countries) => {
      this.countryOptions = ModCountry.toOptions(countries)
    })
  },
}
</script>

<style scoped>
.gender-img {
  height: 55px;
  width: auto;
}
</style>